import type { JEOPARDY_GAME_MAKER_STRINGS } from "@/components/tools/jeopardy-game-maker";
import { useToolLocale, useToolNumber } from "@/components/tools/tool-ui";
import { tPlural } from "@/lib/i18n/interpolate";

type Strings = typeof JEOPARDY_GAME_MAKER_STRINGS;

/** Every team's score; teams in `highlight` stand out. */
export default function JeopardyScores({
  teams,
  scores,
  highlight = [],
  strings,
}: {
  teams: readonly string[];
  scores: readonly number[];
  highlight?: readonly number[];
  strings: Strings;
}) {
  const locale = useToolLocale();
  const fmt = useToolNumber();
  return (
    <ul
      aria-label={strings.scoresLabel}
      className="m-0 flex list-none flex-wrap justify-center gap-2 p-0"
    >
      {teams.map((name, index) => (
        <li
          className={`min-w-[7rem] rounded-lg border px-4 py-2 text-center ${highlight.includes(index) ? "border-primary bg-primary/15" : "border-border bg-card"}`}
          // biome-ignore lint/suspicious/noArrayIndexKey: team names may repeat
          key={index}
        >
          <span className="block font-medium text-foreground text-sm">
            {name}
          </span>
          <span className="block font-bold text-2xl text-foreground">
            {fmt(scores[index] ?? 0)}
          </span>
          <span className="block text-muted-foreground text-xs">
            {tPlural(strings.points, locale, scores[index] ?? 0)}
          </span>
        </li>
      ))}
    </ul>
  );
}
